import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {CurrencyContainerModel} from '../../../../../../models/aggregates/erp/currency';
import { ApiVisa } from '../../shared/api-visa.model';
import { ApiResponseModel } from '../../shared/api-response.model';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class CurrencyService extends BaseApiTemplateService<CurrencyContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'currencies';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'currencies';
    this.httpClient = http;
  }

  public getPublic(visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      this.apiUrl + '/public-ep',
      this.getHttpHeader(visa)
    );
  }

  public getPermCurrency(visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      this.apiUrl + '/login-tenant-ep',
      this.getHttpHeader(visa)
    );
  }
}
